import React, { useState, useEffect } from 'react'
import { Button, Card, Col, Form, Row } from 'antd'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import {
  formItemLayout,
  MonthArr,
  YearArr,
  DateByMonth,
  DateByMonthAndYear,
  DateByYear
} from '../../../../components/_utils/appUtils'
import Request from '../../../../request'
import _ from 'lodash'
import moment from 'moment'

const AbstractFilters = (props) => {
  const { form: { getFieldDecorator, getFieldValue,setFieldsValue}, callback } = props
  let [journalList, setJournalList] = useState([])

  useEffect(() => {
    getJournalList()
  }, [])

  const getJournalList = async () => {
    let { data } = await Request.journalName()
    setJournalList(data.map(item => ({
      _id: item.slugJournal,
      value: item.name,
      display: item.name
    })))
  }

  const inputSchema = {
    fields: [
      {
        label: 'Journal',
        key: 'journal',
        type: 'select',
        options: journalList,
        allowClear: true, // Added this for better UX
        placeholder: 'Select Journal',
        keyAccessor: x => x.value,
        valueAccessor: x => x.value,
        onChange: (val) => setFieldsValue({ journal: val }) // REQUIRED
      },
      {
        label: 'Research Area',
        key: 'researchArea',
        type: 'input',
        placeholder: 'Research Area',
        onChange: (e) => setFieldsValue({ researchArea: e.target.value })
      },
      {
        label: 'Month',
        key: 'month',
        type: 'select',
        options: MonthArr,
        allowClear: true,
        keyAccessor: x => x.value,
        valueAccessor: x => x.name,
        onChange: (val) => setFieldsValue({ month: val })
      },
      {
        label: 'Year',
        key: 'year',
        type: 'select',
        options: YearArr(),
        allowClear: true,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: (val) => setFieldsValue({ year: val })
      }
    ]
  }
  const filterAbstracts = () => {
    let obj = {
      journal: getFieldValue('journal') || null,
      researchArea: getFieldValue('researchArea') || null
    }

    // Date Logic (same as your article filters)
    let year = getFieldValue('year')
    let month = getFieldValue('month')

    if (month && !year) {
      obj.fromDate = moment(DateByMonth(month)).startOf('month')._d
      obj.toDate = moment(DateByMonth(month)).endOf('month')._d
    } else if (year && !month) {
      obj.fromDate = moment(DateByYear(year)).startOf('year')._d
      obj.toDate = moment(DateByYear(year)).endOf('year')._d
    } else if (month && year) {
      obj.fromDate = moment(DateByMonthAndYear(month, year)).startOf('month')._d
      obj.toDate = moment(DateByMonthAndYear(month, year)).endOf('month')._d
    }

    callback(obj)
  }

  return (
    <Form className={'inputForm'}>
      <Row gutter={16}>
        {inputSchema.fields.map((item, key) => (
          <Col span={4} key={key}>
            <GetEachFormFields getFieldDecorator={getFieldDecorator} item={item} formItemLayout={formItemLayout} />
          </Col>
        ))}
        <Col span={4}>
          <Button type='primary' style={{ marginTop: 32 }} onClick={filterAbstracts}>
            FILTER
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(AbstractFilters)
